import React from "react";
import { Button, ButtonGroup } from "@livingdesign/react";
import Recipient from "../../../../../../../pages/v2/Recipient";
import QA from "../../../../../../../consts/QA";
import ModalLD3 from "../../../../../common/Modal/ModalLD3";

export const QA_ID_PREFIX = `${QA.PAGES.HOME}-SavedRecipientsEditModal`;

function SavedRecipientsEditModal({
  isOpen,
  onClose,
  title,
  subTitle,
  onEdit,
  id,
  // canClose = true,
  // loading = false,
  // isPrimaryBtnDisabled = false,
}) {
  return (
    <>
          <ModalLD3
              isOpen={isOpen}
              onClose={onClose}
              title={title}
              actions={
                  <div data-testid={`${QA_ID_PREFIX}-actions`}>
                      <ButtonGroup data-testid={`${QA_ID_PREFIX}-button-group`}>
                          <Button
                              variant="tertiary"
                              size="medium"
                              onClick={() => { 
                                onClose();
                              }}
                              data-testid={`${QA_ID_PREFIX}-cancel-button`}
                          >
                              Cancel
                          </Button>
                          <Button
                              variant="primary"
                              size="medium"
                              onClick={onEdit}
                              data-testid={`${QA_ID_PREFIX}-edit-button`}
                          >
                              Edit Filters
                          </Button>
                      </ButtonGroup>
                  </div>
              }
        size={"medium"}
        id={id}
        data-testid={`${QA_ID_PREFIX}-modal`}
      >{subTitle}</ModalLD3>
    </>
  );
}

export default SavedRecipientsEditModal;